import React, { Component } from 'react';
var PageNum = 0;
class ShowPagination extends Component {
    myRef = [];

    constructor(props) {
        super(props);
        this.state = {
            AllRowCount: this.props.allrowcount,
            RowInPage: this.props.rowinpage,
            SelectPage: this.props.selectpage,
            SelectItems: [],
            PageNum: PageNum
        }
        this.CreatRows = this.CreatRows.bind(this);
        this.HandleClick = this.props.handleclick.bind(this);
    }

    ClickFunction(i) {
        PageNum = i;
        this.HandleClick()
    }
    CreatRows() {
        let counter = 1;
        //myRef = React.createRef();
        for (let i = 0; i < this.state.AllRowCount / this.state.RowInPage; i = i + 1) {
            this.state.SelectItems.push({
                li:

                    <li key={i} className={i == this.state.SelectPage ? "page-item active" : "page-item"} >
                        <a className={"page-link"} onClick={() => this.ClickFunction(i)}>
                            {counter}
                        </a>
                    </li>

            });
            counter++;
        }
        this.setState({
            SelectItems: this.state.SelectItems
        })
    }
    componentDidMount() {
        this.CreatRows();
    }
    render() {
        return <React.Fragment><ul className="pagination">
            {this.state.SelectItems.map(
                (item) => (
                    item.li
                )
            )}
            {/* <li class="page-item active">
                <span class="page-link">
                    2
                <span class="sr-only">(current)</span>
                </span>
            </li> */}
        </ul>
        </React.Fragment>
    }
}
function GetPageParameter() {
    return (PageNum);
}
export { ShowPagination, GetPageParameter };



// WEBPACK FOOTER //
// ./src/component/ShowPagination.js